import React, { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router';
import i18n from 'i18next';
import { useAuth } from '../../_common/AuthContext';
import { Message } from 'primereact/message';

export default function Login() {
    const {auth, setAuth, updateAuth, clearAuth} = useAuth();
    const navigate = useNavigate();
    const [isAuthSuccess, setIsAuthSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [error, setError] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const userIDTypeSetting = false;
    const placeholder = userIDTypeSetting ? 'Email' : 'Email OR username';
    const inputType = userIDTypeSetting ? 'email' : 'text';
    const location = useLocation();

    useEffect(() => {
        if (location.state?.ErrorMessage) {
            setError(location.state?.ErrorMessage);
        }
    }, [location]);

    useEffect(() => {
        clearAuth();
        setLoading(true);
        axios.get(`/BBAuthentication/login`)
            .then(response => {
                const data = response.data;
                if (data.IsSuccess) {
                    setIsAuthSuccess(true);
                    window.location.href = data.ReturnUrl
                } else if (data.RedirectPage) {
                    navigate(data.RedirectPage);
                } else if (data.ErrorMessage) {
                    setIsError(true)
                    setErrorMessage(data.ErrorMessage)
                } else {
                    setAuth(data)
                    if (data.TokenErrorMessage) {
                        setErrorMessage(data.TokenErrorMessage)
                    }
                }
            })
            .catch(error => {
                setErrorMessage(error);
                console.error(error);
            }).finally(() => { 

                setLoading(false);
            });

    }, []);

    const handleSubmit = async (e) => {
        if (e) {
            e.preventDefault();
        }
        setErrorMessage('');

        if (!auth.UserEmail) {
            setErrorMessage(i18n.t('auth.user_id_empty'));
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post('/BBAuthentication/SubmitUser', auth);
            const data = response.data;
            if (data.IsSuccess) {
                navigate(`/authentication`);
            }else{
                setErrorMessage(data.ErrorMessage || i18n.t('auth.invalid_credentials'));
            }
        } catch (err) {
            const serverMsg = err.response?.data || i18n.t('auth.login_failed');
            setErrorMessage(typeof serverMsg === 'string' ? serverMsg : i18n.t('auth.unexpected_error'));
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e, field) => {
        const value = e.target.value;
        const updatedAuth = { ...auth, [field]: value };
        updateAuth(updatedAuth)

        if (errorMessage) {
            setErrorMessage('');
        }
    };
    
    return (
        <>
            {isAuthSuccess && <>
                <div className="login-inner">
                    <div className="body-inner">
                        <div className='login-form'>
                            <div className="text-2xl font-bold text-center">
                                {i18n.t('auth.auth_successfully')}
                            </div>
                            <div className="text-center" style={{ marginTop: '10px' }}>
                                {i18n.t('auth.auth_redirecting')}
                            </div>
                        </div>
                    </div>
                </div>
            </>}
            {isError && (
                <div className="register-inner">
                    <div className="registerbody-inner">
                        <div className="login-form" style={{ textAlign: 'center', alignItems: 'center' }}>
                            {errorMessage && <h4 className="text-red-500 font-bold">{errorMessage}</h4>}
                        </div>
                    </div>
                </div>
            )}
            {!isAuthSuccess && !isError && auth && (
                <div className="login-inner">
                    <div className="body-inner">
                        <form className="login-form" onSubmit={handleSubmit}>
                            <h4 className="mb-3 font-bold">{i18n.t('auth.sign_in')}</h4>
                            <p>{i18n.t('auth.continue')}</p>
                            <div className="max-h-4 mb-4">
                                {(error) && (
                                    <Message severity="error" className='w-full' text={error} />
                                )}
                            </div>
                            <div className="mb-3">
                                <InputText type={inputType} value={auth.UserEmail || ''} onChange={(e) => handleInputChange(e, 'UserEmail')} placeholder={placeholder}
                                           autoComplete="on" autoFocus className={classNames({ 'p-invalid': !!errorMessage })} style={{ width: '100%' }} />
                                {errorMessage && <small className="text-red-500">{errorMessage}</small>}
                            </div>

                            <div className="mb-3">
                                <Button label={i18n.t('auth.next')} className='w-full' loading={loading} disabled={loading} />
                            </div>

                            <div className="mt-4 text-center"> 
                                {i18n.t('auth.dont_have_account')}
                                <a target={auth.IsClientAuthentication ? '_blank' : '_self'} href="/signup/signupAccount" rel="noopener noreferrer" className='p-1 text-primary' >
                                    {i18n.t('auth.create_one')}
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}
